type TitleArtist = {
  readonly title: string;
  readonly artist: string;
};

/**
 * A track counts as played once it passes the listen threshold, while it is still on the deck, so
 * the newest played row is often the song now playing. The server keeps it that way on purpose;
 * only the display drops the duplicate.
 */
export const withoutNowPlaying = <T extends TitleArtist>(
  played: readonly T[],
  nowPlaying: TitleArtist | null | undefined,
): readonly T[] => {
  const [newest, ...rest] = played;
  return newest?.title === nowPlaying?.title && newest?.artist === nowPlaying?.artist
    ? rest
    : played;
};
